import { render, staticRenderFns } from "./AbkContact.vue?vue&type=template&id=68ed00c4&scoped=true&"
import script from "./AbkContact.vue?vue&type=script&lang=js&"
export * from "./AbkContact.vue?vue&type=script&lang=js&"
import style0 from "./AbkContact.vue?vue&type=style&index=0&id=68ed00c4&scoped=true&lang=scss&"
import style1 from "./AbkContact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed00c4",
  null
  
)

export default component.exports